import type { Workspace } from '@carboncopyco/types';
import { ExpandDownIcon, Loading } from '@carboncopyco/ui';
import classNames from 'classnames';
import { WorkspaceItem } from './WorkspaceItem';

interface WorkspaceSelectInputProps {
  open?: boolean;
  disabled?: boolean;
  workspace?: Pick<Workspace, 'workspaceName' | 'color' | 'workspaceType'>;
}

export const WorkspaceSelectInput = ({
  open,
  disabled,
  workspace,
}: WorkspaceSelectInputProps) => {
  return (
    <div
      className={classNames(
        'relative w-full h-9 rounded-ds-md pl-2.5 pr-9 flex items-center border-ds-natural-150 border',
        { 'bg-ds-natural-50 cursor-default': disabled }
      )}
    >
      {workspace ? (
        <WorkspaceItem
          workspace={workspace}
          disabled={disabled}
        />
      ) : (
        <div className="pt-1 my-auto">
          <Loading
            size={16}
            color="text-ds-primary"
          />
        </div>
      )}

      <ExpandDownIcon
        className="absolute right-2 top-0 h-full flex flex-col justify-center"
        rotate={open}
      />
    </div>
  );
};
